const initialState = {
  appraisal: [],
  appraisal_review: [],
  appraisal_history:[],
  all_employee:[],
  error: null,
  isLoding: false
};

const AppraisalApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LODING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_EMPLOYEE_FOR_APPRAISAL_SUCCESS":
      return {
        ...state,
        all_employee: action.payload,
        error: null
      };
    case "GET_EMPLOYEE_FOR_APPRAISAL_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_APPRAISAL_SUCCESS":
      return {
        ...state,
        appraisal: action.payload,
        error: null
      };
    case "GET_APPRAISAL_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_APPRAISAL_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_APPRAISAL_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_APPRAISAL_SUCCESS":
      return {
        ...state,
        appraisal: action.payload,
        // error: action.payload.error
      };

    case "UPDATE_APPRAISAL_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "DELETE_APPRAISAL_SUCCESS":
      return {
        ...state,
        appraisal: action.payload,

        error: null
      };

    case "DELETE_APPRAISAL_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    
    case "GET_APPRAISAL_REVIEW_SUCCESS":
      return {
        ...state,
        appraisal_review: action.payload,
        error: null
      };
    case "GET_APPRAISAL_REVIEW_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_APPRAISAL_REVIEW_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_APPRAISAL_REVIEW_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

     case "UPDATE_APPRAISAL_REVIEW_SUCCESS":
      return {
        ...state,
        appraisal_review: action.payload,
        // error: action.payload.error
      };

    case "UPDATE_APPRAISAL_REVIEW_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_APPRAISAL_HISTORY_SUCCESS":
      return {
        ...state,
        appraisal_history: action.payload,
        error: null
      };
    case "GET_APPRAISAL_HISTORY_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    default:
      return state;
  }
};

export default AppraisalApiReducer;
